<template>
  <div  class="animalsDialogs">
    <div class="animalsDialogBox"  :class="{'filterbgs': grayTheme }" @click="toLogin">
      <img  class="animalsitem1" src="/static/newcenter/animals/dialog2.png" alt="" srcset="">
      <img  class="animalsitem2" src="/static/newcenter/animals/dialog3.png" alt="" srcset="">
      <img  class="animalsitem3" src="/static/newcenter/animals/dialog4.png" alt="" srcset="">
      <img  class="animalsitem4" src="/static/newcenter/animals/dialog1.png" alt="" srcset="">
      <img  class="animalsitem5" @click.stop="closeAll" src="/static/newcenter/animals/dialog5.png" alt="" srcset="">
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        key: 1
      }
    },
    computed:{
      grayTheme(){
        let data = JSON.parse(localStorage.getItem('userSettingInfo') || {}) ; // grayTheme
        return data && data.grayTheme
      }
    },
    methods:{
      toLogin(){
        this.$emit('login')
      },
      closeAll(){
        this.$emit('closeMask')
      }
    }
  }
</script>

<style lang="scss">
  @keyframes myfirst1
  {
     0%   {
       opacity: .7;
       transform:scale(.6);
     }
     8% {
       transform:scale(1) ;
       opacity: 1;
       transition: all .1s;
     }
     100% {
       transform:scale(1) ;
       opacity: 1;
       transition: all .1s;
     }
  }

  @keyframes myfirst2
  {
     0%   {
       opacity:0;
       transform:scale(.6);
     }
     20% {
       opacity: 1;
        transform:scale(1);
        transition: all .1s;
     }
     100% {
       transform:scale(1);
       opacity: 1;
       transition: all .1s;
     }
  }
  @keyframes myfirst3
  {
     0%   {
       transform:scale(1) translateY(20px);
       opacity:0;
     }
     30% {
       transform:scale(1) translateY(0px);
        opacity:1;
     }
     35% {
       transform:scale(1) translateY(0px);
        opacity:1;
     }
     100% {
       transform:scale(1) translateY(0px);
       opacity: 1;
       transition: all .1s;
     }
  }
  @keyframes myfirst4
  {
     0%   {
       transform:scale(.8) translateX(0px);
       opacity:.3;
     }
     5%   {
       opacity:1;
       transform:scale(1)  translateX(0px);
     }
     40%   {
       opacity:1;
       transform:scale(1)  translateX(0px);
     }
     41% {
       transform:translateX(-15px);
        opacity:1;
     }
     42% {
       transform:translateX(0px);
        opacity:1;
     }
     43% {
       transform: translateX(15px);
        opacity:1;
     }
     44% {
       transform: translateX(0px);
        opacity:1;
     }
     100% {
       transform:translateX(0px);
       opacity: 1;
     }
  }

  // @-webkit-keyframes myfirst
  // {
  //     0%   {
  //       transform: scale(1);
  //       background: red;
  //       opacity: 1;
  //       transition: all .1s;
  //     }
  //     25%  {
  //       transform: scale(1);
  //       background: red;
  //       opacity: 1;
  //       transition: all .1s;
  //       background: yellow;
  //     }
  //     50%  {
  //       background: blue;
  //     }
  //     75%  {
  //       background: green;
  //     }
  //     100% {
  //       background: red;
  //     }
  // }

  .animalsDialogs{
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .55);
    .animalsDialogBox{
      transform: scale(.9);
      position: fixed;
      z-index: 999;
      width: 446px;
      height: 372px;
      top:23vh;
      left: 50%;
      margin-left:-223px;
    }
    .animalsitem1{
      transform:scale(.2);
      animation:myfirst1 5s infinite;
      -webkit-animation:myfirst1 5s infinite; /* Safari and Chrome */
      width: 446px;
      height: 372px;
      left: 50%;
      opacity: 0;
      z-index: 1;
      margin-left:-223px;
      position: absolute;
    }
    .animalsitem2{
      animation:myfirst2 5s infinite;
      -webkit-animation:myfirst2 5s infinite; /* Safari and Chrome */
      width: 336px;
      height: 320px;
      left: 50%;
      top: 46px;
      z-index: 2;
      margin-left:-173px;
      position: absolute;
    }
    .animalsitem3{
      animation:myfirst3 5s infinite;
      -webkit-animation:myfirst3 5s infinite; /* Safari and Chrome */
      width: 360px;
      height: 104px;
      position: absolute;
      left: 50%;
      z-index: 4;
      bottom:5px;
      margin-left:-180px;
    }
    .animalsitem4{
      cursor: pointer;
      animation:myfirst4 5s infinite;
      -webkit-animation:myfirst4 5s infinite; /* Safari and Chrome */
      width: 173px;
      height: 43px;
      opacity:1;
      position: absolute;
      left: 50%;
      z-index: 5;
      bottom:-64px;
      margin-left:-86px;
    }

    .animalsitem5{
      width: 32px;
      cursor: pointer;
      height: 32px;
      position: absolute;
      left: 50%;
      z-index: 5;
      bottom:-120px;
      margin-left:-16px;
      transition: all .2s;
    }
    .animalsitem5:hover{
      transform: rotate(90deg);
      transition: all .2s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_animalDialog.vue